import { ReactElement, useState } from 'react';
import { Button, Group, Paper, Text } from '@mantine/core';
import { PractitionerOption } from '@/hooks/usePractitionersByRoles';
import { OnCallPractitionerSelects } from './OnCallPractitionerSelects';

interface OnCallBulkEditToolbarProps {
  selectedCount: number;
  practitionerOptions: PractitionerOption[];
  practitionersLoading: boolean;
  disabled?: boolean;
  onApply: (primaryId: string | null, backupId: string | null) => Promise<void>;
}

export function OnCallBulkEditToolbar({
  selectedCount,
  practitionerOptions,
  practitionersLoading,
  disabled = false,
  onApply,
}: OnCallBulkEditToolbarProps): ReactElement | null {
  const [primaryId, setPrimaryId] = useState<string | null>(null);
  const [backupId, setBackupId] = useState<string | null>(null);
  const [applying, setApplying] = useState(false);

  if (selectedCount === 0) {
    return null;
  }

  const handleApply = async () => {
    setApplying(true);
    try {
      await onApply(primaryId, backupId);
      setPrimaryId(null);
      setBackupId(null);
    } finally {
      setApplying(false);
    }
  };

  return (
    <Paper withBorder p="md" mb="md">
      <Group align="flex-end" wrap="wrap">
        <Text fw={600}>{selectedCount} row(s) selected</Text>
        <Group align="flex-end" wrap="wrap">
          <OnCallPractitionerSelects
            primaryId={primaryId}
            backupId={backupId}
            practitionerOptions={practitionerOptions}
            loading={practitionersLoading}
            disabled={disabled || applying}
            onChange={(nextPrimaryId, nextBackupId) => {
              setPrimaryId(nextPrimaryId);
              setBackupId(nextBackupId);
            }}
          />
        </Group>
        <Button color="blue" disabled={disabled || applying} loading={applying} onClick={() => void handleApply()}>
          Apply to {selectedCount} row(s)
        </Button>
      </Group>
    </Paper>
  );
}
